import { Component, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { NKDatetime } from 'ng2-datetime/ng2-datetime';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
    selector: 'datepicker',
    template: `
        <div class="ng2-datetime">
            <div [ngClass]="{ 'form-group': true, 'input-group': !datepickerOptions.hideIcon, 'date': true }">
                <div [hidden]="datepickerOptions.hideIcon || datepickerOptions === false || !datepickerOptions.preicon"
                        (click)="showDatepicker()"
                        class="input-group-prepend">
                    <span class="input-group-text"><i [ngClass]="datepickerOptions.preicon"></i></span>
                </div>
                <input id="{{idDatePicker}}" type="text" class="form-control"
                        [attr.readonly]="readonly"
                        [attr.required]="required"
                        [attr.placeholder]="datepickerOptions.placeholder || 'Choose date'"
                        [attr.tabindex]="tabindex"
                        [(ngModel)]="dateModel"
                        (change)="inputOnChange()"
                        (blur)="onTouched()"
                        (keyup)="checkEmptyValue($event)"/>
                <div [hidden]="datepickerOptions.hideIcon || datepickerOptions === false || !datepickerOptions.icon"
                        (click)="showDatepicker()"
                        class="input-group-append">
                    <span class="input-group-text"><i [ngClass]="datepickerOptions.icon || 'glyphicon glyphicon-th'"></i></span>
                </div>
                <div class="invalid-feedback" [class.pl-4]="datepickerOptions.preicon"
                    *ngIf="datepickerOptions && datepickerOptions.feedbackText">
                    {{datepickerOptions.feedbackText}}
                </div>
            </div>
            <div [ngClass]="{ 'form-group': true, 'input-group': !timepickerOptions.hideIcon, 'bootstrap-timepicker timepicker': true }">
                <input id="{{idTimePicker}}" type="text" class="form-control input-small"
                        [attr.readonly]="readonly"
                        [attr.required]="required"
                        [attr.placeholder]="timepickerOptions.placeholder || 'Set time'"
                        [attr.tabindex]="tabindex"
                        [(ngModel)]="timeModel"
                        (focus)="showTimepicker()"
                        (blur)="onTouched()"
                        (keyup)="checkEmptyValue($event)">
                <span [hidden]="timepickerOptions.hideIcon || false" class="input-group-append">
                    <i [ngClass]="timepickerOptions.icon || 'glyphicon glyphicon-time'"></i>
                </span>
            </div>
            <button *ngIf="hasClearButton" type="button" (click)="clearModels()">Clear</button>
        </div>
        `,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
    }]
})
export class DatePickerComponent extends NKDatetime implements ControlValueAccessor {

    @Output('change')
    hostchange = new EventEmitter();


    registerOnChange(fn: (_: any) => void) {
        
        this.onChange = (_: any) => {
            fn(_);
            this.hostchange.emit(_);
        }
    }


    inputOnChange() {
        if (this.dateModel && this.dateModel.length > 0) {
            this.date = new Date(this.dateModel + "GMT+0900");
            this.onChange(this.date);
        }
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/date/datepicker.compoment.ts